import styled from 'styled-components'
import { VerticalStyledScrollBar } from '~/styles'

export const PropertiesContainer = styled.div`
  margin-top: 1rem;
  padding-bottom: 1.5rem;
  display: flex;
  flex: 1;
  gap: 1rem;
  flex-direction: column;
  overflow: hidden;
`
export const ContentContainer = styled.div.attrs(props => ({
  scrollbarBackground: props.theme.zds.colors.neutral1000
}))`
  display: flex;
  flex: 1;
  height: 100%;
  flex-direction: column;
  overflow: auto;
  gap: 1rem;

  ${VerticalStyledScrollBar}
`

export const PropertyTitle = styled.h3`
  position: relative;
  margin-bottom: 1rem;

  font-size: 1.15rem;
  text-align: center;
  font-weight: bold;
  color: ${props => props.theme.colors.color6b7786};
`

export const CompareButton = styled.button`
  width: 116px;
  height: 39px;
  background: ${props => props.theme.colors.color378ff7} 0% 0% no-repeat padding-box;
  border-radius: 4px;
  text-align: center;
  font: normal normal medium 14px/21px Inter;
  color: ${({ theme }) => theme.zds.colors.neutral1000};

  &:hover {
    opacity: 0.7;
  }
`

export const ButtonsPanel = styled.div``

export const CheckContainer = styled.div`
  margin-bottom: 1rem;
`

export const MessageError = styled.p`
  margin-top: 1rem;
  font-size: 0.8rem;
  color: ${props => props.theme.colors.color545e6c};
  text-align: center;
`

export const LoaderPropertyContainer = styled.div`
  margin-top: 15px;
  display: flex;
  gap: 1rem;
  flex-direction: column;

  .title {
    margin-bottom: 1rem;
    display: flex;
    justify-content: center;
  }

  .checkbox {
    width: 20px;
    height: 20px;
    border-radius: 2px;
  }

  .property {
    width: 50%;
    height: 20px;
  }
`

export const LoaderProperty = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  > div {
    display: flex;
    gap: 0.5rem;
  }
`
